import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.less';
import FixedContainer, { FixedContainerProps } from '@base/lib/FixedContainer';
import cn from 'classnames';
import { addClass, removeClass } from 'ava-util/dist/dom-class';
import { getScrollBarWidth } from 'ava-util/dist/dom-window';

type FullMaskProps = FixedContainerProps & {
    visible: boolean;
    duration?: number; //动画过渡时间
    keepScrollbar?: boolean;
};

const DEFAULT_DURATION = 150; //透明度过渡时间

const FullMask: React.FC<FullMaskProps> = props => {
    const {
        visible,
        duration = DEFAULT_DURATION,
        keepScrollbar = false,
        className,
        ...restProps
    } = props;
    const [block, setBlock] = useState<boolean>(false);
    const [opacity, setOpacity] = useState<boolean>(false);
    const [offset, setOffset] = useState<[number | string, number | string]>();
    const maskRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (visible) {
            if (!keepScrollbar) {
                addClass(document.body, 'overflow', false);
                document.body.style.paddingRight = `${getScrollBarWidth()}px`;
            }
            setBlock(true);
            setOffset(void 0);
            setTimeout(() => {
                if (maskRef.current) {
                    const rect = maskRef?.current?.getBoundingClientRect();
                    setOffset([`${0 - rect.left}px`, `${0 - rect.top}px`]);
                }
                setOpacity(true);
            }, 10)
        } else {
            if (!keepScrollbar) {
                removeClass(document.body, 'overflow', false);
                document.body.style.paddingRight = '';
            }
            setOpacity(false);
            setTimeout(() => {
                setBlock(false);
            }, duration);
        }
    }, [visible]);

    return (
        <FixedContainer
            {...restProps}
            ref={maskRef}
            className={cn(
                className,
                styles.mask,
                { [styles.block]: block },
                { [styles.opacity]: opacity },
            )}
            width="100vw"
            height="100vh"
            placement={['left', 'top']}
            offset={offset}
        />
    );
};

export default FullMask;